export default __webpack_public_path__ + "static/media/plurato-sailfin-efoil-3.d5310b22.jpg";